module.exports = __webpack_public_path__ + "img/glodon-big-data-qrcode.9053adc8.jpg";